<template>
  <div class="cargoWarehousingDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.cargoWarehousing.label1 }}</div>

      <van-field
        v-model="content.PWB_Number"
        :label="$t.cargoWarehousing.mainWbNumber"
        label-class="number-label"
        disabled
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.PWB_Number)"
            v-if="content.PWB_Number"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="content.WB_Number"
        :label="$t.cargoWarehousing.sideWbNumber"
        label-class="number-label"
        disabled
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.WB_Number)"
            v-if="content.WB_Number"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="content.AllBoxNumber"
        :label="$t.cargoWarehousing.totalNumber"
        disabled
      />
      <van-field
        v-model="content.AllWeight"
        :label="$t.cargoWarehousing.totalWeight"
        disabled
      />
      <van-field
        v-model="content.AllVolume"
        :label="$t.cargoWarehousing.totalValue"
        disabled
      />
      <van-field
        v-model="isCodorderStr"
        :label="$t.cargoWarehousing.isCodorder"
        readonly
      />
      <van-field
        v-model="content.MawbNumber"
        :label="$t.cargoWarehousing.mawbNumber"
        readonly
      />

      <div class="title">{{ $t.cargoWarehousing.label2 }}</div>

      <van-field
        v-model="content.ConsigneeName"
        :label="$t.cargoWarehousing.consignee"
        disabled
      />
      <van-field
        v-model="content.ConsigneePhone"
        :label="$t.cargoWarehousing.consigneePhone"
        disabled
      />
      <van-field
        v-model="content.ConsigneeAddress"
        :label="$t.cargoWarehousing.consigneeAddress"
        disabled
        type="textarea"
      />
      <van-field
        v-model="content.ReceiveCountryCity"
        :label="$t.cargoWarehousing.pod"
        disabled
      />

      <div class="title">{{ $t.cargoWarehousing.label3 }}</div>

      <van-field :label="$t.cargoWarehousing.headPhoto" readonly>
        <template #input>
          <van-image
            class="fieldImg"
            :src="imgUrlFilter(content.DriverHeadPhoto)"
            @click="
              content.DriverHeadPhoto
                ? imagePreview(imgUrlFilter(content.DriverHeadPhoto))
                : false
            "
          >
            <template v-slot:error>{{ $t.cargoWarehousing.noImage }}</template></van-image
          >
        </template>
      </van-field>
      <van-field
        v-model="content.DriverName"
        :label="$t.cargoWarehousing.driverName"
        disabled
      />
      <van-field
        v-model="content.DriverPhoneNumber"
        :label="$t.cargoWarehousing.phoneNumber"
        disabled
      />
      <van-field :label="$t.cargoWarehousing.vehiclePhoto" readonly>
        <template #input>
          <van-image
            class="fieldImg"
            :src="imgUrlFilter(content.VehiclePhoto)"
            @click="
              content.VehiclePhoto
                ? imagePreview(imgUrlFilter(content.VehiclePhoto))
                : false
            "
          >
            <template v-slot:error>{{ $t.cargoWarehousing.noImage }}</template></van-image
          >
        </template>
      </van-field>
      <van-field
        v-model="content.LicensePlate"
        :label="$t.cargoWarehousing.licensePlate"
        disabled
      />

      <van-field v-model="content.Color" :label="$t.cargoWarehousing.color" disabled />

      <van-field :label="$t.cargoWarehousing.cargoReceivedPhoto" readonly>
        <template #input>
          <van-image
            class="fieldImg"
            :src="imgUrlFilter(content.CargoReceivedPhoto)"
            @click="
              content.CargoReceivedPhoto
                ? imagePreview(imgUrlFilter(content.CargoReceivedPhoto))
                : false
            "
          >
            <template v-slot:error>{{ $t.cargoWarehousing.noImage }}</template></van-image
          >
        </template>
      </van-field>
      <van-field
        v-model="content.CargoReceivedPhotoUploadTime"
        :label="$t.cargoWarehousing.uploadTime"
        disabled
      />

      <van-field :label="$t.cargoWarehousing.cargoArrivalPhoto" readonly>
        <template #input>
          <van-image
            class="fieldImg"
            :src="imgUrlFilter(content.CargoArrivalPhoto)"
            @click="
              content.CargoArrivalPhoto
                ? imagePreview(imgUrlFilter(content.CargoArrivalPhoto))
                : false
            "
          >
            <template v-slot:error>{{ $t.cargoWarehousing.noImage }}</template></van-image
          >
        </template>
      </van-field>
      <van-field
        v-model="content.CargoArrivalPhotoUploadTime"
        :label="$t.cargoWarehousing.uploadTime"
        disabled
      />

      <div class="title">{{ $t.cargoWarehousing.label4 }}</div>

      <van-field
        v-model="content.WarehouseCode"
        :label="$t.cargoWarehousing.warehouseCode"
        disabled
      />
      <van-field
        v-model="content.WarehouseName"
        :label="$t.cargoWarehousing.warehouseName"
        disabled
      />
      <van-field
        v-model="content.WarehouseAddress"
        :label="$t.cargoWarehousing.warehouseAddress"
        disabled
        type="textarea"
      />
      <van-field :label="$t.cargoWarehousing.storageHeadPhoto" readonly>
        <template #input>
          <van-image
            class="fieldImg"
            :src="imgUrlFilter(content.StorageHeadPhoto)"
            @click="
              content.StorageHeadPhoto
                ? imagePreview(imgUrlFilter(content.StorageHeadPhoto))
                : false
            "
          >
            <template v-slot:error>{{ $t.cargoWarehousing.noImage }}</template></van-image
          >
        </template>
      </van-field>
      <van-field
        v-model="content.StorageName"
        :label="$t.cargoWarehousing.storageName"
        disabled
      />
      <van-field
        v-model="content.StoragePhoneNumber"
        :label="$t.cargoWarehousing.storagePhoneNumber"
        disabled
      />
      <van-field
        v-model="content.CargoWarehousingTime"
        :label="$t.cargoWarehousing.cargoWarehousingTime"
        disabled
      />
      <van-field
        v-model="content.ApplyOutboundTime"
        :label="$t.cargoWarehousing.applyOutboundTime"
        disabled
      />
      <van-field
        v-model="outboundTypeStr"
        :label="$t.cargoWarehousing.outboundTypeLabel"
        disabled
      />

      <div class="title">{{ $t.cargoWarehousing.label5 }}</div>

      <van-field :label="$t.cargoWarehousing.deliveryPersonHeadPhoto" readonly>
        <template #input>
          <van-image
            class="fieldImg"
            :src="imgUrlFilter(content.DeliveryPersonHeadPhoto)"
            @click="
              content.DeliveryPersonHeadPhoto
                ? imagePreview(imgUrlFilter(content.DeliveryPersonHeadPhoto))
                : false
            "
          >
            <template v-slot:error>{{ $t.cargoWarehousing.noImage }}</template></van-image
          >
        </template>
      </van-field>
      <van-field
        v-model="content.DeliveryPersonName"
        :label="$t.cargoWarehousing.deliveryPersonName"
        disabled
      />
      <van-field
        v-model="content.DeliveryPersonPhoneNumber"
        :label="$t.cargoWarehousing.deliveryPersonPhoneNumber"
        disabled
      />
      <van-field
        v-model="content.DeliveryTime"
        :label="$t.cargoWarehousing.deliveryTime"
        disabled
      />
      <van-field
        v-model="content.CompletionTime"
        :label="$t.cargoWarehousing.completionTime"
        disabled
      />

      <div class="title">{{ $t.cargoWarehousing.label6 }}</div>

      <div
        class="list-container"
        v-for="(item, index) in content.WaybillDetailList"
        :key="index"
      >
        <div class="list-item">
          {{ $t.cargoWarehousing.goodsName }}：{{ item.GoodsDescribe }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.hsCode }}：{{ item.CustomsCode }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.orderPiece }}：{{ item.BoxNumber }}
        </div>
        <div class="list-item">{{ $t.cargoWarehousing.weight }}：{{ item.Weight }}</div>
        <div class="list-item">{{ $t.cargoWarehousing.volume }}：{{ item.Volume }}</div>
        <div class="list-item">
          {{ $t.cargoWarehousing.goodsValue }}：{{ item.ItemPrice }} {{ item.Currency }}
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "cargoWarehousingDetail",
  data() {
    return {
      ECWBId: "",
      content: {},
      isCodorderStr: "",
      outboundTypeStr: "",
    };
  },
  created() {
    const { ECWBId } = this.$route.query;
    this.ECWBId = ECWBId;
    this.getExpressCargoWaybillInfoByECWBId();
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getExpressCargoWaybillInfoByECWBId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          ECWBId: this.ECWBId,
        };
        this.$api.storage
          .getExpressCargoWaybillInfoByECWBId(param)
          .then((res) => {
            this.content = res.data;
            if (this.content.is_codorder == 1) {
              this.isCodorderStr = this.$t.meta.yes;
            }
            if (this.content.is_codorder == 0) {
              this.isCodorderStr = this.$t.meta.no;
            }
            if (this.content.OutboundType == 1) {
              this.outboundTypeStr = this.$t.cargoWarehousing.outboundType1;
            }
            if (this.content.OutboundType == 2) {
              this.outboundTypeStr = this.$t.cargoWarehousing.outboundType2;
            }
            this.$commonMethod.fieldRefresh(".cargoWarehousingDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.cargoWarehousingDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  ::v-deep .van-field__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .fieldImg {
    width: 80px;
    height: 80px;

    .userImg {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    ::v-deep .van-image__error {
      position: block;
    }

    ::v-deep .van-image__img {
      object-fit: contain;
    }
  }

  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;

    .custom-field-label {
      width: 120px;
      font-size: 14px;
      margin-right: 12px;
      color: #323233;
      display: inline-block;
      vertical-align: middle;
    }

    .custom-field-value {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .list-container {
    font-size: 12px;
    color: #333;
    padding: 10px;
    margin-top: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);

    .list-item {
      margin-bottom: 10px;
      width: 50%;
      display: inline-block;
    }

    .list-item:nth-last-child(2) {
      margin-bottom: 0px;
    }

    .list-item:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
